import { v4 as uuidv4 } from 'uuid';

/**
 * Generates a unique cell ID using UUID v4 and the provided index.
 * @param index - The index to append to the generated ID.
 * @returns A string in the format `cell-<uuid>-<index>`.
 */
export default function generateUniqueId(index?: number){
  if(index === undefined) return `cell-${uuidv4()}`
  return `cell-${uuidv4()}-${index}`
}